import { IRapportInfo } from '../../../../../Types/RapportInfoType';
// import { rapportInfos } from '../RapportInfo';

const KRRapportMeny: IRapportInfo[] = [];

export default KRRapportMeny;
